import React, { ComponentProps } from "react";
import { LegacyText, Flex } from "flicket-ui";
import startCase from "lodash/startCase";

const STATUS_COLORS = {
  Completed: "success",
  PartPaid: "success50",
  Paid: "success",
  Success: "success",
  Waiting: "warning",
  Pending: "warning",
  Unknown: "warning",
  Transferred: "warning",
  Hold: "warning50",
  Expired: "N300",
  Error: "error",
  Failure: "error",
  Canceled: "error",
  Precharge: "#0D80F2",
};

type TagProps = ComponentProps<typeof Flex> & {
  status: string;
  dot?: number;
  textProps?: ComponentProps<typeof LegacyText>;
};

export const Tag = ({
  status,
  height = 24,
  dot = 16,
  textProps = {},
  ...props
}: TagProps) => {
  return (
    <Flex
      display="inline-flex !important"
      borderRadius="full"
      bg="N200"
      p="1/2"
      pr={1}
      alignItems="center"
      height={height}
      color="N700"
      fontSize={1}
      {...props}
    >
      <Flex
        borderRadius="full"
        width={dot}
        height={dot}
        bg={STATUS_COLORS[status]}
        mr="1/2"
      />
      <LegacyText fontWeight="extraBold" {...textProps}>
        {startCase(status)}
      </LegacyText>
    </Flex>
  );
};
